<script lang="ts">
    
    import AppWrapper from "../components/AppWrapper.svelte";

</script>

<AppWrapper>
    <div class="m-5">
        <div class="p-5 mb-4 bg-light rounded-3">
            <div class="container-fluid py-5">
              <h1 class="display-5 fw-bold">Bienvenidos</h1>
              <p class="col-md-8 fs-4">CheckForm - Plataforma de gestión de formularios</p>
            </div>
          </div>
    </div>

</AppWrapper>